import React     from 'react';
import { Link }       from 'react-router-dom';
import { Observe }    from 'rewire-core';
import { ICell }      from 'rewire-grid';
import { withStyles } from 'rewire-ui';
import { Theme }      from '@material-ui/core/styles';
import Typography     from '@material-ui/core/Typography';

const styles = (_theme: Theme) => ({
  link: {
    width: '100%',
    textDecoration: 'none',
    cursor: 'pointer',
  },
  type: {
    fontSize: '1.1em',
    fontWeight: 'bold',
    color: '#336498',
    cursor: 'pointer',
  },
});

const LinkCell: React.SFC<{cell: ICell; classes?: Record<string, string>}> = React.memo(withStyles(styles, (props) => {
  const {cell, classes} = props;
  const to              = cell.column.typeOptions && cell.column.typeOptions.to;

  // if to or to(cell) do not return a value, default to cell.value.id
  let typeClass = classes!.type;
  let route     = to && to(cell);
  if (!route) {
    route     = cell.value.id;
    typeClass = '';
  }

  return <Observe>{() => {
    let value = cell.value;
    if (cell.column.map) {
      value = cell.column.map(value);
    }

    return typeClass
      ? <Link className={classes!.link} to={route}><Typography variant='body2' className={classes!.type} title={value} >{value}</Typography></Link>
      : <Typography variant='body2' className={typeClass}>{value}</Typography>;
    }}</Observe>;

}));

export default LinkCell;
